import {NgModule} from '@angular/core';
import {FesAutocompleteDialogComponent} from './fes-autocomplete-dialog.component';
import {DsvsInlineEditModule} from '@dsvs/dsvs-shared-ui-lib';
import {CommonModule} from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    DsvsInlineEditModule,
  ],
  declarations: [
    FesAutocompleteDialogComponent
  ],
  exports: [
    FesAutocompleteDialogComponent
  ]
})
export class FesAutocompleteDialogModule {
}




